// extracted by mini-css-extract-plugin
export default {"melodyVideo":"EJ-z","isFullWidth":"FJ-z","landingPageVideo":"GJ-z","play":"HJ-z","iframeVideo":"IJ-z","playHidden":"JJ-z","fullwidth":"KJ-z"};